export default {
  description: {
    id: 'bo_seller_profile_page_epr_block_description',
    defaultMessage:
      'Add your EPR numbers to sell in the markets below. Not sure where to find yours or need to register? Contact your Back Market point of contact for details.',
  },
  fetchEprInformationErrorMessage: {
    id: 'bo_seller_profile_page_epr_block_fetch_error_message',
    defaultMessage: 'Something went wrong while fetching your EPR information.',
  },
  fetchErrorTitle: {
    id: 'bo_seller_profile_page_epr_block_fetch_error_title',
    defaultMessage: 'Oops!',
  },
  title: {
    id: 'bo_seller_profile_page_epr_block_title',
    defaultMessage: 'Extended Producer Responsibility (EPR)',
  },
}
